// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"757b840a","853":"496c5544","889":"7d430af1"}[chunkId] + ".chunk.js";
};